import type { InvariantJiraRoute } from '@atlassian/jira-route-types/src/InvariantJiraRoute.tsx';

export const helpCenterSettingsArticlesViewArticleRoute: InvariantJiraRoute = {
	name: 'helpcenter-settings-articles-view-article',
	path: '/jira/helpcenter/projects/:projectKey/settings/:helpCenterId/articles/:articleId',
	exact: true,
};
